import React, { useContext, useEffect, useState } from "react";
import Banner from "./banner/Banner";
import Category from "./category/Category";
import "./Home.css";
import Festival_Banner from "./festival_banner/Festival_Banner";
import Products from "./products/Products";
import Products_Without_Bg from "./products_without_bg/Products_Without_Bg";
import { Context } from "../../utils/context";
import { luxuryHomeOccassion } from "../../utils/luxuryapis/Home/Homeapi";
import { encodeId } from "../../utils/common";

const LuxuryHome = () => {
  const { IMG_URL } = useContext(Context);
  const [homeoccassion, setHomeOccassion] = useState();
  console.log(homeoccassion, "homeoccassionhomeoccassion");

  const getAllLuxuryHomeOccassion = async () => {
    const res = await luxuryHomeOccassion();
    if (res?.success) {
      setHomeOccassion(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryHomeOccassion();
  }, []);

  return (
    <section className="LuxuryHome">
      <Banner />
      <Category />

      {homeoccassion?.map((item) => {
        const products = item?.home_occassion_multiples
          ?.slice(0, 4)
          ?.map((element) => {
            // PRODUCT TYPE
            if (item?.type === "Product" && element?.product) {
              return {
                name: element?.product?.name,
                img: IMG_URL + element?.product?.image1,
                link: `/luxury/product-details/${encodeId(element?.product?.id)}`,
              };
            }

            // CATEGORY TYPE
            if (item?.type === "Category" && element?.category) {
              return {
                name: element?.category.name,
                img: IMG_URL + element?.category?.image,
                link: `/luxury/products?category_id=${element?.category.id}&name=${element?.category.name}`,
              };
            }

            return null;
          })
          ?.filter(Boolean);

        return (
          <React.Fragment key={item.id}>
            {/* Festival Banner */}
            <Festival_Banner
              title={item?.name}
              subtitle={item?.sub_name}
              bannerImg={IMG_URL + item?.image}
            />

            {/* Products */}
            <Products data={products} />
          </React.Fragment>
        );
      })}

      {/* <Festival_Banner
        title="TIMELESS ELEGANCE"
        subtitle="Where precision meets artistry, the ODA Carved Lion Cufflinks come to life. Gold-plated and exquisitely detailed, they embody effortless sophistication, creating a lasting impression"
        bannerImg="/assest/luxury_images/home/banner/banner2.png"
      />

      <Products_Without_Bg data={producsData2} />

      <Festival_Banner
        title="A TOUCH OF REFINED SOPHISTICATION"
        subtitle="Elegance starts with precision. A sleek line of stainless steel that defines, a polished finish that captivates... and with every detail, the world of style is effortlessly elevated."
        bannerImg="/assest/luxury_images/banners/banner3.png"
      />

      <Products_Without_Bg data={producsData3} /> */}
    </section>
  );
};

export default LuxuryHome;
